import script from "./BetBoostSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBoostSidebar.vue?vue&type=script&setup=true&lang=js"

import "./BetBoostSidebar.vue?vue&type=style&index=0&id=26b84291&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b84291"]])

export default __exports__